module.exports = __webpack_public_path__ + "img/sound-5-image.4cf0e9ba.jpg";